import { configureStore } from "@reduxjs/toolkit";
import Auth from "./slices/authSlice";
import Alert from "./slices/alertSlice";
import Roles from "./slices/rolesSlice";
import modal from "./slices/modalSlice";
import Users from "./slices/usersSlice";
import Customers from "./slices/customersSlice";
import Settings from "./slices/settingsSlice";
import Membership from "./slices/membershipSlice";
import VehicleMake from "./slices/vehicleMakeSlice";
import vehicleModel from "./slices/vehicleModelSlice";
import vehicleColor from "./slices/vehicleColorSlice";
import Branches from "./slices/branchesSlice";
import WashHistory from "./slices/washHistorySlice";
import Banners from "./slices/bannersSlice";
import Notification from "./slices/notificationSlice";
import NotificationRules from "./slices/notificationRulesSlice";
import APILogs from "./slices/apiLogsSlice";
import CommonActions from "./slices/commonSlice";
import Dashboard from "./slices/dashboardReducer";
import Coupons from "./slices/couponSlice";
import PageContent from "./slices/pageContentSlice";
import StoreCamera from "./slices/storeCameraSlice";
import DynamicPrices from "./slices/dynamicPricesSlice";
import Reports from "./slices/reportsSlice";


export const store = configureStore({
  reducer: {
    Auth,
    Alert,
    Roles,
    modal,
    Users,
    Customers,
    Settings,
    Membership,
    VehicleMake,
    vehicleModel,
    vehicleColor,
    Branches,
    WashHistory,
    Banners,
    Notification,
    APILogs,
    NotificationRules,
    CommonActions,
    Dashboard,
    Coupons,
    PageContent,
    StoreCamera,
    DynamicPrices,
    Reports
  },
});
